import React from 'react';
import HeroComponent from '../components/homepage/HeroComponent';
import StepsComponent from '../components/homepage/StepsComponent';
import AboutComponent from '../components/homepage/AboutComponent';
import WorkComponent from '../components/homepage/WorkComponent';
import ServicesComponent from '../components/homepage/ServicesComponent';
import CTAComponent from '../components/homepage/CTAComponent';

const HomePage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <HeroComponent />
                <StepsComponent />
                <AboutComponent />
                <WorkComponent />
                <ServicesComponent />
                <CTAComponent />
            </div>
        </main>
    );
};

export default HomePage;
